<div class="story-end-container">
    <div class="story-end-falling-stars-container">
        <h1 *ngIf="!levelManagerService.isLevelUp">{{ 'storyEnd.text1' | translate}}</h1>
        <h1 *ngIf="levelManagerService.isLevelUp">{{ 'storyEnd.text2' | translate}}</h1>
        <h3 *ngIf="levelManagerService.isLevelUp" [innerHTML]="'storyEnd.text3' | translate: { value: levelManagerService.newReadingLevel }"></h3>
        <div [innerHTML]="safeAvatarSVG" class="end-page-avatar-svg-container"></div>
        <!-- <img src="../../../../assets/imgs/star_icon.png" class="story-finish-image"/> -->
        <h3 [innerHTML]="'storyEnd.text4' | translate: { value: storyService.storySessionModel.expPointsEarned }"></h3>
        <h4 [innerHTML]="'storyEnd.text5' | translate: { value: levelManagerService.expPointsRequiredForNextLevel }"></h4>
    </div>
    <progress-bar [progress]="levelManagerService.levelProgressBarValue" [color]="'#6155A1'">
    </progress-bar>
    <div class="btn-container">
        <button class="btn btn-secondary" (click)="replayStory()">{{ 'storyEnd.text6' | translate}}</button>
        <button class="btn btn-secondary" (click)="backToHome()">
            <mat-icon>home</mat-icon> {{ 'storyEnd.text7' | translate}}
        </button>
        <button *ngIf="!isAssignmentMode" class="btn btn-secondary" (click)="passQuiz()">{{ 'storyEnd.text8' | translate}}</button>
    </div>

</div>
<!-- <script src="https://code.responsivevoice.org/responsivevoice.js?key=e5dGgiAW"></script> -->
